module.exports = __webpack_public_path__ + "img/34ne.565b14d4.svg";